module.exports = __webpack_public_path__ + "files/18ff215139246918d1f1a1c5d04b1775.png";